import { render, staticRenderFns } from "./tl-exclusions.vue?vue&type=template&id=672d6b1c&scoped=true"
import script from "./tl-exclusions.vue?vue&type=script&lang=js"
export * from "./tl-exclusions.vue?vue&type=script&lang=js"
import style0 from "./tl-exclusions.vue?vue&type=style&index=0&id=672d6b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d6b1c",
  null
  
)

export default component.exports